var classes = {
  "root": "m_b6d8b162"
};
export { classes as default };